import React from 'react';
import { Card } from 'antd';
import LoginForm from '../components/Auth/LoginForm';
import { useTranslation } from "react-i18next";
import '../assets/CSS/LoginPage.css';
const LoginPage: React.FC = () => {
  const { i18n, t } = useTranslation();

  return (
    <div className='login-background' style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', direction: i18n.language === 'ar' || i18n.language === 'ckb' ? 'rtl' : 'ltr' }}>
      <Card title={t('login')} style={{ width: 300 }}>
        <LoginForm />
      </Card>
    </div>
  );
};

export default LoginPage;